<header class="header">
  <div class="header-content">
    <div class="d-block d-md-none">
      <button class="sidebar-toggle-btn mt-0" (click)="toggleSidebar()">
        <span class="hamburger mt-0">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
    </div>
    <div class="logo">
      <!-- <a routerLink="/dashboard" class="logo-link">
        <img
          src="assets/images/main-logo.svg"
          alt="Whopper Ads Logo"
          class="logo-image"
          width="100"
          height="65"
        />
      </a> -->
      <div class="d-none d-md-inline-block">
        <button class="sidebar-toggle-btn" (click)="toggleSidebar()">
          <span class="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-3">
      <div
        #notificationMenuRef
        class="notification-menu"
        [class.notification-menu--open]="notificationsOpen"
      >
        <button
          type="button"
          class="notification-trigger"
          (click)="toggleNotifications($event)"
          [attr.aria-expanded]="notificationsOpen"
          aria-haspopup="true"
          aria-controls="header-notifications-panel"
          [attr.aria-label]="
            unreadCount > 0 ? 'Notifications, ' + unreadCount + ' unread' : 'Notifications'
          "
        >
          <span class="notification-icon" [class.notification-icon--active]="notificationsOpen">
            <i class="bi bi-bell" aria-hidden="true"></i>
            @if (unreadCount > 0) {
              <span class="badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
            }
          </span>
        </button>

        @if (notificationsOpen) {
          <div
            id="header-notifications-panel"
            class="notification-panel"
            role="dialog"
            aria-label="Notifications"
            aria-modal="false"
          >
            <div class="panel-header">
              <div class="title">Notifications</div>
              <button
                type="button"
                class="mark-all"
                (click)="markAllAsRead($event)"
                [disabled]="!notifications.length || unreadCount === 0"
              >
                Mark all read
              </button>
            </div>

            <div class="panel-body" (scroll)="onScroll($event)">
              @if (notificationsLoading && notifications.length === 0) {
                <div class="loading-skeleton" aria-busy="true">
                  @for (s of [1, 2, 3]; track s) {
                    <div class="skeleton-row">
                      <div class="skeleton-line skeleton-line--title"></div>
                      <div class="skeleton-line skeleton-line--msg"></div>
                      <div class="skeleton-line skeleton-line--meta"></div>
                    </div>
                  }
                </div>
              } @else if (notifications.length === 0) {
                <div class="empty-state">
                  <i class="bi bi-bell-slash empty-icon" aria-hidden="true"></i>
                  <p class="empty-title">You're all caught up</p>
                  <p class="empty-sub">No new notifications right now.</p>
                </div>
              } @else {
                <ul class="notification-list">
                  @for (n of notifications; track n.id) {
                    <li class="notification-item" [class.unread]="!n.isRead">
                      <div class="item-title">{{ n.title }}</div>
                      <div class="item-message">{{ n.message }}</div>
                      <div class="item-meta">
                        <span class="item-time">{{ formatNotificationTime(n.createdAt) }}</span>
                        @if (!n.isRead) {
                          <button type="button" class="mark-read" (click)="markAsRead(n, $event)">
                            Mark read
                          </button>
                        }
                      </div>
                    </li>
                  }
                </ul>
                @if (isLoadingMore) {
                  <div class="loading-more text-center">
                    <div class="spinner-border spinner-border-sm text-primary m-2" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>

      <div
        class="user-menu"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="menuOpen"
        aria-haspopup="true"
        aria-label="User menu"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
        (keydown.space)="$event.preventDefault(); toggleMenu()"
      >
        <!-- <i class="bi bi-person-circle avatar-icon"></i> -->
        <div class="d-flex justify-content-center align-items-center gap-2">
          <div class="avatar-circle">
            {{ avatarLetter }}
          </div>
          <div class="user-name">{{ user?.first_name }} {{ user?.last_name }}</div>
        </div>

        @if (menuOpen) {
          <div class="dropdown-card">
            <div class="user-info">
              <div class="avatar-circle large">
                {{ avatarLetter }}
              </div>

              <div class="user-details">
                <div class="user-name">{{ user?.first_name }} {{ user?.last_name }}</div>
                <div class="user-role">
                  {{ user?.role?.name }}
                </div>
              </div>
            </div>

            <div class="divider"></div>

            <button type="button" class="logout-btn" (click)="logout($event)">
              <i class="bi bi-box-arrow-right"></i>
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</header>
